import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateTimePipe } from './pipes/date-time.pipe';
import { FileSizePipe } from './pipes/file-size.pipe';
import { AntdModule } from '../Antd.module';
import { HasClickEntitlementDirective } from './directives/has-click-entitlement.directive';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { HeaderComponent } from './components/header/header.component';
import { LoginComponent } from './components/login/login.component';
import { LayoutComponent } from './components/layout/layout.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TrimFormInputDirective } from './directives/trim-form-input.directive';
import { MonacoEditorComponent } from './components/monaco-editor/monaco-editor.component';
import { ResizableColumnDirective } from './directives/resizable-column.directive';
import { MonacoEditorBotComponent } from './components/monaco-editor-bot/monaco-editor-bot.component';

@NgModule({
  declarations: [
    DateTimePipe,
    FileSizePipe,
    SidebarComponent,
    HeaderComponent,
    LoginComponent,
    LayoutComponent,
    MonacoEditorComponent,
    MonacoEditorBotComponent,
  ],
  imports: [
    CommonModule,
    AntdModule,
    HasClickEntitlementDirective,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TrimFormInputDirective,
    ResizableColumnDirective,
  ],
  exports: [
    DateTimePipe,
    FileSizePipe,
    HasClickEntitlementDirective,
    SidebarComponent,
    HeaderComponent,
    LoginComponent,
    LayoutComponent,
    TrimFormInputDirective,
    MonacoEditorComponent,
    ResizableColumnDirective,
    MonacoEditorBotComponent,
  ],
})
export class SharedModule {}
